import { validateProps } from '../../utils';
import { isValidBase } from '../BaseEntity';
export const isValidBrainSimulation = properties => {
  const ans = isValidBase(properties) && validateProps(properties, ['name', 'description', 'initialNoteExamples', 'additionalNoteExamples', 'simulationSize', 'taskReferences', 'supervisorRunningStatus', 'simulationFinished']);
  return ans;
};
//# sourceMappingURL=BrainSimulation.js.map